// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"213e3d9f","217":"b810bca5","302":"213e3d9f","360":"feef6459"}[chunkId] + ".chunk.css";
};